<template lang="pug">
.Modeling
  app-header
    .ModelingMenu
      b.Menu-title МОДЕЛИРОВАНИЕ:
      .ModelingMenu-nav(v-if='!isPublicWs')
        header-button(
          :isActive='panels.services',
          title='Процессы',
          icon='IconPanelServices',
          @clicked='panels.services = !panels.services'
        )
        header-button(
          :isActive='panels.history',
          title='История действий',
          icon='IconPanelHistory',
          @clicked='panels.history = !panels.history'
        )

      .ModelingMenu-sound
        switcher(
          v-model='soundParam',
          @mouseover='toggleSoundHelperText',
          @mouseout='helperText = null'
        ) Звук
        button.Btn.BtnIcon(
          @click='openSoundPopup',
          @mouseover.stop='helperText = "Выбор звука уведомления"',
          @mouseout.stop='helperText = null'
        )
          i.Icon.IconMenuSettings

  .Modeling-spinner(v-if='!isPublicWs && isInitLoading')
    fade-loader.Spinner(
      :loading='isInitLoading',
      color='#27bd8a',
      height='8px',
      width='3px',
      radius='10px'
    )
  .SP(v-if='isPublicWs')
    forbidden-for-public
  .SP(v-if='workspace && version && !isInitLoading && !isPublicWs')
    splitpanes.hscreen(
      vertical='',
      @resized='changePanes',
      @ready='ready = true',
      min-size='25',
      @pane-add='changePanes',
      @pane-remove='changePanes',
      ref='panes'
    )
      pane(
        v-if='panels.services',
        paneId='services',
        min-size='35',
        :size='currentSizes.services',
        :dbl-click-splitter='false',
        :flexible='true'
      )
        layout-panel(
          @close='panels.services = false',
          titleHtml='Процессы'
        )
          template(v-slot:content='')
            modeling-services
      pane(
        v-if='panels.params',
        paneId='params',
        min-size='30',
        :size='currentSizes.params',
        :dbl-click-splitter='false'
      )
        layout-panel(
          @close='panels.params = false',
          titleHtml='Настройки процесса'
        )
          template(v-slot:content='')
            modeling-service-parameters
      pane(
        v-if='panels.history',
        paneId='history',
        min-size='15',
        max-size='35',
        :size='currentSizes.history',
        :dbl-click-splitter='false'
      )
        layout-panel(
          @close='panels.history = false',
          titleHtml='История действий'
        )
          template(v-slot:content='')
            modeling-history
</template>

<script>
import ModelingServiceParameters from '@/components/modeling/ServiceParameters.vue'
import ModelingServices from '@/components/modeling/Services.vue'
import ModelingHistory from '@/components/modeling/History.vue'
import AppHeader from '@/components/AppHeader'
import LayoutPanel from '@/components/LayoutPanel'
import { Splitpanes, Pane } from '@/components/splitpanes'
import HeaderButton from '@/components/HeaderButton.vue'
import Switcher from '@/components/Switcher.vue'
import ModelingSound from '@/components/popups/ModelingSound.vue'
import FadeLoader from 'vue-spinner/src/FadeLoader'
import common from '@/mixins/common'
import panes from '@/mixins/panes'
import ForbiddenForPublic from '@/components/ForbiddenForPublic'
import helpertext from '@/mixins/helpertext'

export default {
  name: 'Modeling',

  mixins: [common, panes, helpertext],

  components: {
    ForbiddenForPublic,
    AppHeader,
    HeaderButton,
    ModelingServiceParameters,
    ModelingServices,
    ModelingHistory,
    LayoutPanel,
    Splitpanes,
    Pane,
    Switcher,
    FadeLoader
  },

  data() {
    return {
      panels: {
        history: true,
        params: false,
        services: true
      },
      currentSizes: {
        history: 25,
        params: 35,
        services: 75
      },
      soundParam: false,
      newMapContainerSize: null
    }
  },
  computed: {
    isInitLoading() {
      return this.$store.getters.isInitLoading
    },
    selectedService() {
      return this.$store.getters.modelingSelectedService
    },
    workspace() {
      return this.$store.getters.workspace
    },
    version() {
      return this.$store.getters.version
    },
    workspaceAndVersion() {
      return { workspace: this.workspace, version: this.version }
    },
    modelingSound() {
      return this.$store.getters.modelingSound
    }
  },
  watch: {
    selectedService(newVal) {
      this.panels.params = !!newVal
    },
    workspaceAndVersion(newVal, oldVal) {
      if (oldVal.workspace && newVal.workspace !== oldVal.workspace) {
        this.$store.dispatch('clearAllModeling')
      } else if (oldVal.version && oldVal.version !== newVal.version) {
        this.$store.dispatch('clearModeling')
      }
    },
    soundParam() {
      this.$store.commit('setModelingSound', this.soundParam ? 1 : 0)
      this.toggleSoundHelperText()
    }
  },
  beforeDestroy() {
    this.$store.dispatch('clearAllModeling')
  },
  mounted() {
    this.soundParam = !!this.modelingSound
  },
  methods: {
    openSoundPopup() {
      this.$ui.popup.show({
        component: ModelingSound
      })
    },

    toggleSoundHelperText() {
      this.helperText = this.soundParam ? 'Выключить звук' : 'Включить звук'
    }
  }
}
</script>
<style scoped lang="scss">
@import '~base';
.ModelingMenu {
  display: flex;
  align-items: center;

  &-nav {
    display: flex;
    align-items: center;
    margin-left: 15px;
  }

  &-sound {
    display: flex;
    align-items: center;
    margin-left: 20px;
    font-size: 14px;

    .Btn {
      margin-left: 10px;

      .Icon {
        font-size: 16px;
        color: var(--secondaryText);
      }

      &:hover {
        .Icon {
          color: var(--accentColor);
        }
      }
    }
  }
}
.Modeling {
  &-spinner {
    position: fixed;
    top: 50%;
    left: 50%;
    margin: -16px 0 0 -16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Modeling.vue